var TscMediaOrganizationType = {
  folder: 'folder',
  collection: 'collection'
};
export default TscMediaOrganizationType;